import { anim, stagger } from '../../../../motion'
import { Check } from '../../../../primitives'
import { Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import { MaskText } from '../../stage/fx'

// Jeder Satz bekommt die Bühne, die Partikel spielen ihn mit:
// gleiche Aufgaben (Raster), keine Unterschiede (alles weiß), kein Durchfallen (Kreis), etwas über dich (Herz)
const START = 0.2
const SPAN = 0.15
const spot = (i) => [START + i * SPAN, START + (i + 1) * SPAN]

const grid = (tint) => (w, h) => ({
  type: 'grid',
  x: w / 2,
  y: h / 2,
  width: w * 0.92,
  height: h * 0.86,
  opacity: 0.4,
  tint
})

export const FAIR_PARTICLES = [
  [0.04, () => ({ type: 'scatter', alpha: 0.45, seed: 61 })],
  [spot(0)[0] + 0.03, grid()],
  [spot(1)[0] + 0.03, grid('white')],
  [
    spot(2)[0] + 0.03,
    (w, h) => ({
      type: 'ring',
      x: w / 2,
      y: h / 2,
      r: Math.min(w, h) * 0.42,
      tint: 'white'
    })
  ],
  [
    spot(3)[0] + 0.03,
    (w, h) => ({
      type: 'heart',
      x: w / 2,
      y: h * 0.5,
      size: Math.min(h * 0.86, w * 0.6),
      opacity: 0.35,
      dot: 1
    })
  ],
  [0.86, () => ({ type: 'scatter', alpha: 0.3, seed: 63 })]
]

export default function CsFair() {
  const c = useCopy('fair')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <div className='cs-fair-intro'>
        <Line at={[-1, 0]} out={[0.14, 0.2]} className='sc-eyebrow cs-light'>
          {s.fairKicker}
        </Line>
        <h2 className='sc-display'>
          <MaskText text={c.title} at={[0.01, 0.1]} out={[0.15, 0.2]} />
        </h2>
        <Line
          at={[0.08, 0.13]}
          out={[0.15, 0.2]}
          y={20}
          className='cs-fair-text'
        >
          {c.text}
        </Line>
      </div>

      {c.points.map((p, i) => {
        const [a, b] = spot(i)
        return (
          <div key={p} className='cs-statement'>
            <span
              className='cs-statement__num'
              style={anim({ at: [a, a + 0.03], out: [b - 0.03, b], y: 30 })}
            >
              0{i + 1}
            </span>
            <div className='sc-display cs-statement__text'>
              <MaskText
                text={p}
                at={[a + 0.01, a + 0.07]}
                out={[b - 0.03, b]}
              />
            </div>
          </div>
        )
      })}

      <div className='cs-fair-final'>
        <div style={anim({ at: [0.82, 0.88], y: 40 })}>
          <h2 className='sc-h2'>{c.title}</h2>
          <p className='cs-fair-text cs-fair-text--left'>{c.text}</p>
        </div>
        <ul className='cs-fair-list'>
          {c.points.map((p, i) => (
            <li
              key={p}
              style={anim({ at: stagger(0.84, 0.025, 0.05, i), x: 60, y: 0 })}
            >
              <Check size={26} color='#fff' />
              {p}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
